/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMNIds } from "./GMNIds";
import { GMNIdsFromJSON, GMNIdsFromJSONTyped, GMNIdsToJSON, GMNIdsToJSONTyped } from "./GMNIds";

/**
 *
 * @export
 * @interface ApiGmnIdsList200Response
 */
export interface ApiGmnIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmnIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmnIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmnIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMNIds>}
   * @memberof ApiGmnIdsList200Response
   */
  results: Array<GMNIds>;
}

/**
 * Check if a given object implements the ApiGmnIdsList200Response interface.
 */
export function instanceOfApiGmnIdsList200Response(
  value: object
): value is ApiGmnIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmnIdsList200ResponseFromJSON(json: any): ApiGmnIdsList200Response {
  return ApiGmnIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmnIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmnIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMNIdsFromJSON),
  };
}

export function ApiGmnIdsList200ResponseToJSON(json: any): ApiGmnIdsList200Response {
  return ApiGmnIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGmnIdsList200ResponseToJSONTyped(
  value?: ApiGmnIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMNIdsToJSON),
  };
}
